import component from "containers/PaymentRequired";

export default {
  key: "payment-required",
  title: "Payment Required",
  path: "/payment-required",
  linkTarget: "/payment-required",
  component,
};
